import React, { useState, useEffect, useRef, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom"; // Added useSearchParams
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import { handleErrorToast } from "../../CustomFunctions";
import { fetchExistingLetterTemplate } from "../../CustomUtilities";
import ReactDOMServer from "react-dom/server";
import TemplateDisplayWrapper from "../LetterDisplayComponents/TemplateDisplayWrapper";
import { LetterPreview } from "../LetterDisplayComponents/LetterPreview";

const EmployeeLetterViewPR = () => {
  const [employeeLetter, setEmployeeLettersData] = useState({});
  const [templateData, setTemplateData] = useState();
  const [buffer, setBuffering] = useState(true);
  const ref = useRef();
  let { id } = useParams();
  
  // NEW: Grab the query parameter from the URL (e.g., ?emp=CIPL10036)
  const [searchParams] = useSearchParams();
  const empCodeFromUrl = searchParams.get("emp");

  // Determine the target employee code (URL parameter takes priority for email links, fallback to session for internal navigation)
  const targetEmpCode = empCodeFromUrl || sessionStorage.getItem("emp_code");

  const [loading, setLoading] = useState(true);
  const [letterTemplate, setLetterTemp] = useState({});
  const [subCompany, setSubCompany] = useState({});

  const [isClient, setIsClient] = useState(false);
  const [processedContent, setProcessedContent] = useState("");

  useEffect(() => {
    setIsClient(true);
  }, []);

  const checkVariables = employeeLetter?.employee_letter_variables;

  function decodeHtmlEntities(str) {
    if (typeof window === "undefined") return str;

    const textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value;
  }

  // function replaceVariables(content, empDetail) {
  //   if (!empDetail || !Array.isArray(empDetail)) return content;

  //   const variableMap = empDetail.reduce((map, item) => {
  //     map[item.var_key] =
  //       item.var_value === "" ? item.var_name : item.var_value;
  //     return map;
  //   }, {});

  //   const decodedContent = decodeHtmlEntities(content);

  //   return decodedContent?.replace(/{{(\d+)}}/g, (match, varKey) => {
  //     const varName = variableMap[varKey];

  //     if (varName) {
  //       return ` ${empDetail[0]?.var_value ? varName : `{{${varName}}}`}`;
  //     }
  //     return match;
  //   });
  // }

  // UPDATED: Automatically finds the correct variables based on targetEmpCode
  function replaceVariables(content, empDetail, targetCode) {
    if (!content || !empDetail || !empDetail.length) return content;

    let parsedVarJson = empDetail[0]?.var_json;
    
    if (typeof parsedVarJson === 'string') {
        try {
            parsedVarJson = JSON.parse(parsedVarJson);
        } catch (e) {
            console.error("Failed to parse var_json", e);
            return content;
        }
    }

    if (!parsedVarJson || !Array.isArray(parsedVarJson)) return decodeHtmlEntities(content);

    // Auto-detect the correct employee index based on the emp_code
    let targetIndex = 0; 
    if (targetCode) {
      const foundIndex = parsedVarJson.findIndex((emp) => emp.emp_code === targetCode);
      if (foundIndex !== -1) {
        targetIndex = foundIndex;
      }
    }

    // Get the variables specifically for the matched employee
    const variablesArray = parsedVarJson[targetIndex]?.variables;
    const decodedContent = decodeHtmlEntities(content);

    if (!variablesArray || !Array.isArray(variablesArray)) {
        return decodedContent;
    }

    return decodedContent.replace(/{{(\d+)}}/g, (match, varKey) => {
      const variableObj = variablesArray.find(
        (item) => String(item.var_key) === String(varKey)
      );

      if (variableObj) {
        return variableObj.var_value 
          ? variableObj.var_value 
          : `[${variableObj.var_name}]`;
      }

      return match;
    });
  }

  useEffect(() => {
    if (employeeLetter?.description) {
      const updatedContent = replaceVariables(
        employeeLetter?.description,
        checkVariables,
        targetEmpCode // Pass the targeted employee code
      );
      setProcessedContent(updatedContent);
    }
  }, [employeeLetter?.description, checkVariables, targetEmpCode]);

  const lineHeight = employeeLetter?.letter_format_data?.line_height

  const finalContent = useMemo(() => {
    if (typeof processedContent === "string") {
      return processedContent;
    }
    if (processedContent) {
      return ReactDOMServer.renderToStaticMarkup(processedContent);
    }
    return "";
  }, [processedContent]);

  const getEmployeeSlipByID = async (id) => {
    if (!id) return;
    setBuffering(true);
    setLoading(true);
    try {
      const letter = await axios.get(
        `${BASE_URL}/wfm/letter-builder-complete-employee-letter-byid/${id}/`
      );

      setEmployeeLettersData(letter?.data);
      setTemplateData(letter?.data.letter_template_data);
    } catch (error) {
      handleErrorToast(error);
    } finally {
      setBuffering(false);
      // setLoading(false);
    }
  };

  const loadLetterTemplate = async () => {
    try {
      const { template, subcompany } = await fetchExistingLetterTemplate({
        subcompanyId: employeeLetter?.sub_company,
        letterTemplateId: employeeLetter?.letter_template,
        emp_code: employeeLetter?.multiple_emp_code?.[0],
      });

      if (template) setLetterTemp(template);
      if (subcompany) setSubCompany(subcompany);
    } catch (err) {
      // toast.warning("Could not fetch letter template");
    }
  };

  useEffect(() => {
    if (
      !employeeLetter?.sub_company ||
      !employeeLetter?.letter_template
    )
      return;

    loadLetterTemplate();
  }, [employeeLetter?.sub_company, employeeLetter?.letter_template, employeeLetter?.emp_code])

  useEffect(() => {
    getEmployeeSlipByID(id);
  }, [id]);

  return (
    <>
      <TemplateDisplayWrapper
        // onBack={backroute}
        ref={ref}
        downloadEnable={false}
      >
        {/* Dropdown removed! The employee will only see their own letter data automatically. */}
      </TemplateDisplayWrapper >
      <LetterPreview
        letterTemplateData={letterTemplate}
        subCompany={subCompany}
        buffer1={buffer}
        ref={ref}
        lineHeight={lineHeight}
        showDefaultSignText={true}
      >
        {finalContent}
      </LetterPreview>
    </>
  )
};

export default EmployeeLetterViewPR;